import React from 'react';

import type { SummaryReview } from '@/api/ahafood/get-store-fn';
// import { useCityRoutes } from '@/hooks/use-city-navigation';
// import { usePathname } from '@/i18n/routing';
import AiGen from '@/public/static/icons/ai-gen.svg';

type AiSummaryHighlightProps = {
  summary?: SummaryReview;
};

export default function AiSummaryHighlight({
  summary,
}: AiSummaryHighlightProps) {
  // const pathName = usePathname();
  // const routes = useCityRoutes();
  if (!summary?.highlights) return null;

  return (
    <div className="relative w-full flex items-start gap-2 bg-gradient-to-br from-yellow-10 to-white rounded-lg pl-4 py-1.5 border-none">
      <AiGen className="absolute -top-1 -left-1 size-7 shrink-0" />
      <p className="text-xs text-neutral-70 font-medium leading-relaxed">
        {summary.highlights}
      </p>
    </div>
  );
}
